import { erc20Abi, type PublicClient } from "viem";
import { SupportedChains, type THexString, type TTokenInfo } from "./types";


export async function getTokenInfo(client: PublicClient, tokenAddress: THexString, eth_address?: THexString ) {
    
  
    // Get token decimals
    const decimals = await client.readContract({
      address: tokenAddress,
      abi: erc20Abi,
      functionName: 'decimals'
    }) as number;

    const name = await client.readContract({
        address: tokenAddress,
        abi: erc20Abi,
        functionName: 'name'
      }) as string;

      const symbol = await client.readContract({
        address: tokenAddress,
        abi: erc20Abi,
        functionName: 'symbol'
      }) as string;

      let balance = BigInt(0);
      if (eth_address) {
        balance = await client.readContract({
            address: tokenAddress,
            abi: erc20Abi,
            args: [eth_address],
            functionName: 'balanceOf'
          }) ;
      }
      
    return {
        address: tokenAddress,
        name,
        symbol,
        decimals,
        eth_address,
        balance
    } as TTokenInfo 


}
